function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useMemo, useState } from "react";
import { TIERS } from "constants/pricing";
import { GenericConfigContext } from "/contexts/generic-config-context";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import classnames from "classnames";
import DownArrow from "/static/svg/arrow-down.svg";
import ChevronSvg from "./svgs/chevron-svg";
import Button from "components/core/button/button-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { withAbTests } from "/contexts/ab-tests-context";
import { getPricingContactUsLink } from "services/pricing/pricing-page/contact-us-link-service";
import { getTierTranslationKey } from "services/pricing/plans-service";
import { ProductIcon } from "segments/desktop/pricing/icons/product-icon";
import { trackEvent } from "services/bigbrain-service";
import { HOMEPAGE_PRICING_TIER_SOURCE } from "constants/cookies";
import { SEE_COMPLETE_FEATURES_LIST_CLICKED, CONTACT_US_BUTTON_CLICKED } from "constants/bigbrain-event-types";
import { ProductFeaturesTableSection } from "./product-features-table-section/product-features-table-section";
import { setCookie } from "/services/cookies-service";
import { StyledProductFeaturesTable } from "./product-features-table.scss";
import { CREDITS_PER_TIER, TIERS_WITH_CREDITS_DROPDOWN, buildCreditsMondayAiTable, MONDAY_LOGO_URL, getCreditsPerSeatAmount } from "constants/pricing/credits-config";
import { CRM_PRODUCT_ID, PLATFORM_PRODUCT_IDS, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { CreditsSelect } from "segments/desktop/pricing/layouts/prices-and-features-cards-pricing/product-prices-and-features-cards/credits-select/credits-select-component";
const ProductFeaturesTable = ({ productName: currentProductName, isExpanded: isExpandedProp, setIsExpanded: setIsExpandedProp, abTests, hideFreeTier, hasFreeTier, isNewPricing, shouldHideBasicTier, useClassicCardChrome, creditsPerSeat = false })=>{
    const currentProduct = productPricingConfig[currentProductName];
    const isCrmClassic = useClassicCardChrome && currentProductName === CRM_PRODUCT_ID;
    const { translate, simulateEnterpriseToUltimateRenameTest, simulateGetQuoteAndScrollToForm, enableCreditsPricing, localeId } = useContext(GenericConfigContext);
    const [localIsExpanded, setLocalIsExpanded] = useState(false);
    const controlledMode = setIsExpandedProp !== undefined;
    const setIsExpanded = controlledMode ? setIsExpandedProp : setLocalIsExpanded;
    const isExpanded = controlledMode ? isExpandedProp : localIsExpanded;
    const toggleFeaturesList = useCallback(()=>{
        const newToggleValue = !isExpanded;
        setIsExpanded(newToggleValue);
        trackEvent(SEE_COMPLETE_FEATURES_LIST_CLICKED, {
            info1: newToggleValue ? "shown" : "hidden",
            productKind: currentProductName,
            button_name: "dropdown_features_list_pricing_page"
        });
    }, [
        setIsExpanded,
        isExpanded
    ]);
    const isFeatureListEmpty = useCallback(()=>{
        const product = productPricingConfig[currentProductName];
        if (!product || !product.featuresList) {
            return true;
        }
        return product.featuresList.length === 0;
    }, []);
    const getTiers = useCallback(()=>{
        if (!hasFreeTier || hideFreeTier) {
            return currentProduct.tiers.filter((tier)=>tier.name !== TIERS.FREE);
        }
        return currentProduct.tiers;
    }, [
        currentProduct,
        hasFreeTier,
        hideFreeTier
    ]);
    const handleBeforeSubmitCallback = (tierName)=>{
        setCookie(HOMEPAGE_PRICING_TIER_SOURCE, `${currentProductName}-${tierName}`);
    };
    const productName = translate(`pricingPage.products.${currentProductName}.longTitleBold`);
    const isCreditsEnabled = enableCreditsPricing && currentProductName === PLATFORM_PRODUCT_IDS[WORK_MANAGEMENT_PRODUCT_ID];
    const [selectedCreditsPerTier, setSelectedCreditsPerTier] = useState({});
    const handleCreditsChange = useCallback((tier, credits)=>{
        setSelectedCreditsPerTier((prev)=>_object_spread_props(_object_spread({}, prev), {
                [tier]: credits
            }));
    }, []);
    const baseFeaturesList = isNewPricing ? currentProduct.newFeaturesList : currentProduct.featuresList;
    const featuresList = useMemo(()=>{
        if (!isCreditsEnabled) {
            return baseFeaturesList;
        }
        const dynamicMondayAi = buildCreditsMondayAiTable(selectedCreditsPerTier);
        const withoutMondayAi = baseFeaturesList.filter((section)=>section.sectionName !== "mondayAi");
        const essentialsIndex = withoutMondayAi.findIndex((section)=>section.sectionName === "essentials");
        const insertIndex = essentialsIndex >= 0 ? essentialsIndex + 1 : 0;
        const result = [
            ...withoutMondayAi
        ];
        result.splice(insertIndex, 0, dynamicMondayAi);
        return result;
    }, [
        isCreditsEnabled,
        baseFeaturesList,
        selectedCreditsPerTier
    ]);
    const filteredTiers = shouldHideBasicTier ? getTiers().filter((tier)=>tier.name !== TIERS.BASIC) : getTiers();
    return /*#__PURE__*/ _jsxs(StyledProductFeaturesTable, {
        className: "product-features-table",
        isNewPricing: isNewPricing,
        isCrmClassic: isCrmClassic,
        numberOfTiers: filteredTiers.length,
        role: "table",
        style: {
            "--primary-color": currentProduct.primaryColor,
            "--secondary-color": currentProduct.secondaryColor,
            "--logo-color": currentProduct.switcherIconColor
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("toggle", {
                    expanded: isExpanded,
                    "crm-classic": isCrmClassic
                }),
                onClick: ()=>toggleFeaturesList(),
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        children: translate(isCrmClassic ? "pricingPage.completeFeatureListClassic" : "pricingPage.completeFeaturesList")
                    }),
                    isCrmClassic ? /*#__PURE__*/ _jsx(ChevronSvg, {
                        className: "arrow-down"
                    }) : /*#__PURE__*/ _jsx(DownArrow, {
                        className: "arrow-down"
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ _jsxs("div", {
                className: "grid",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tier-header"
                    }),
                    filteredTiers.map((tier)=>{
                        var _getCreditsPerSeatAmount, _translate, _CREDITS_PER_TIER_tier_name, _translate1, _CREDITS_PER_TIER_tier_name1, _translate2;
                        return /*#__PURE__*/ _jsxs("div", {
                            className: "tier-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "tier-title",
                                    children: translate(getTierTranslationKey(tier.name, {
                                        hasStudentPlan: false,
                                        productName: currentProductName,
                                        abTests,
                                        forceUltimateRename: simulateEnterpriseToUltimateRenameTest
                                    }))
                                }),
                                isCreditsEnabled && /*#__PURE__*/ _jsx("div", {
                                    className: "tier-credits",
                                    style: tier.name === TIERS.FREE ? {
                                        visibility: "hidden"
                                    } : undefined,
                                    children: creditsPerSeat ? tier.name === TIERS.ENTERPRISE ? /*#__PURE__*/ _jsx("span", {
                                        children: translate("pricingPage.tierAiBlock.creditsPerSeat.enterprise.customCredits")
                                    }) : /*#__PURE__*/ _jsx("span", {
                                        children: (_translate = translate("pricingPage.credits.header.perSeat")) === null || _translate === void 0 ? void 0 : _translate.replace("{amount}", (_getCreditsPerSeatAmount = getCreditsPerSeatAmount(tier.name)) === null || _getCreditsPerSeatAmount === void 0 ? void 0 : _getCreditsPerSeatAmount.toLocaleString(localeId || undefined))
                                    }) : TIERS_WITH_CREDITS_DROPDOWN.includes(tier.name) ? /*#__PURE__*/ _jsx(CreditsSelect, {
                                        tier: tier.name,
                                        onCreditsChange: (credits)=>handleCreditsChange(tier.name, credits),
                                        compact: true,
                                        selectedValue: selectedCreditsPerTier[tier.name],
                                        placement: "feature_list"
                                    }) : tier.name === TIERS.ENTERPRISE ? /*#__PURE__*/ _jsx("span", {
                                        children: (_translate1 = translate("pricingPage.credits.header.enterprise")) === null || _translate1 === void 0 ? void 0 : _translate1.replace("{amount}", (_CREDITS_PER_TIER_tier_name = CREDITS_PER_TIER[tier.name]) === null || _CREDITS_PER_TIER_tier_name === void 0 ? void 0 : _CREDITS_PER_TIER_tier_name.toLocaleString(localeId || undefined))
                                    }) : /*#__PURE__*/ _jsx("span", {
                                        children: (_translate2 = translate("pricingPage.credits.header.monthly")) === null || _translate2 === void 0 ? void 0 : _translate2.replace("{amount}", (_CREDITS_PER_TIER_tier_name1 = CREDITS_PER_TIER[tier.name]) === null || _CREDITS_PER_TIER_tier_name1 === void 0 ? void 0 : _CREDITS_PER_TIER_tier_name1.toLocaleString(localeId || undefined))
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "tier-cta",
                                    children: tier.name !== TIERS.ENTERPRISE ? /*#__PURE__*/ _jsx(SignupFormComponent, {
                                        buttonSize: "xs",
                                        extraData: {
                                            pricing_tier: tier.name,
                                            cta_name: "full_feature_list",
                                            productKind: currentProductName
                                        },
                                        beforeSubmitCallback: ()=>handleBeforeSubmitCallback(tier === null || tier === void 0 ? void 0 : tier.name),
                                        useCtaText: isNewPricing,
                                        ctaText: isNewPricing ? translate("signup.tryForFree") : null,
                                        className: isNewPricing ? "tier-cta-button" : undefined
                                    }) : /*#__PURE__*/ _jsx(Button, {
                                        type: "button",
                                        buttonSize: "xs",
                                        onClickCallback: ()=>{
                                            trackEvent(CONTACT_US_BUTTON_CLICKED, {
                                                info1: "enterprise",
                                                placement: "feature_list"
                                            });
                                            if (simulateGetQuoteAndScrollToForm) {
                                                const formElement = document.getElementById("form");
                                                if (formElement) {
                                                    formElement.scrollIntoView({
                                                        behavior: "smooth"
                                                    });
                                                    return;
                                                }
                                            }
                                            window.location.href = getPricingContactUsLink(abTests);
                                        },
                                        children: translate(simulateGetQuoteAndScrollToForm ? "pricingPage.get_quote" : "footer.contactSales")
                                    })
                                })
                            ]
                        }, `tier-header-${tier.name}`);
                    }),
                    !isFeatureListEmpty() && /*#__PURE__*/ _jsxs("div", {
                        className: "product-section-header",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: classnames("icon-container", {
                                    "monday-logo-container": isCreditsEnabled
                                }),
                                children: isCreditsEnabled ? /*#__PURE__*/ _jsx("img", {
                                    className: "product-section-logo",
                                    src: MONDAY_LOGO_URL,
                                    alt: "monday"
                                }) : /*#__PURE__*/ _jsx(ProductIcon, {
                                    product: `${currentProductName}White`,
                                    className: "product-section-logo"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: classnames("product-name", {
                                    "monday-product-name": isCreditsEnabled
                                }),
                                dangerouslySetInnerHTML: {
                                    __html: isCreditsEnabled ? "monday" : productName
                                }
                            })
                        ]
                    }),
                    !isFeatureListEmpty() && (featuresList === null || featuresList === void 0 ? void 0 : featuresList.map((productSection)=>/*#__PURE__*/ _jsx(ProductFeaturesTableSection, {
                            productSection: productSection,
                            productName: currentProductName,
                            hideFreeTier: hideFreeTier,
                            hasFreeTier: hasFreeTier,
                            isNewPricing: isNewPricing,
                            shouldHideBasicTier: shouldHideBasicTier,
                            isCrmClassic: isCrmClassic
                        }, productSection.sectionName)))
                ]
            })
        ]
    });
};
export default withAbTests(ProductFeaturesTable);
